var _effectorFileName = "/src/page-content/home/components/why-work-with-us/why-work-with-us.tsx";
import { useUnit } from 'effector-react';
import { HOW_WORK_STARTS_LIST } from '@/page-content/landing/constants/how-work-starts';
import { Article } from '@/shared/components/article';
import { CardCustom } from '@/shared/components/card-custom';
import { ContactForm } from '@/shared/components/contact-form';
import { $isContactFormSentSuccessfully, contactFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData } from '@/shared/components/contact-form/types';
import { LineWithCircles } from '@/shared/components/line-with-circles';
import { TextGradient } from '@/shared/components/text-gradient';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
import { WORK_WITH_US_PLUSES_LIST } from '../../constants/pluses-list';
export const WhyWorkWithUs = () => {
  const {
    isContactFormSentSuccessfully,
    onContactFormSend
  } = useUnit({
    onContactFormSend: contactFormDataSent,
    isContactFormSentSuccessfully: $isContactFormSentSuccessfully
  });
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSend(data);
  };
  return <Article>
      <div className="grid items-center gap-6 sm:gap-10 md:grid-cols-2 md:grid-rows-none lg:gap-20">
        {/* <TextPlusesList items={WORK_WITH_US_PLUSES_LIST} /> */}

        <div className="mx-auto sm:mx-0">
          <LineWithCircles className="mb-10">
            {HOW_WORK_STARTS_LIST.map((step, index) => <div key={index}>
                <h3 className="mb-3 header-h3 sm:mb-5">{step.title}</h3>

                <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{
              __html: step.description
            }} />
              </div>)}
          </LineWithCircles>

          <p className="max-w-3xl text-muted-foreground">
            Мы&nbsp;экономим ваше время, исключая ненужные темы. Вместо шаблонных программ&nbsp;&mdash; мы&nbsp;создаем
            персональный план обучения, основанный именно на&nbsp;ваших потребностях
          </p>
        </div>

        <CardCustom isCardDataSentSuccessfully={isContactFormSentSuccessfully} className="mx-auto w-full max-w-lg " cardClassName="pt-12 pb-2">
          <TextGradient tag="h3" text="Проведем пробный урок" className="mb-1.5 text-center text-2xl font-medium !tracking-tight" />

          <p className="mb-6 text-center text-muted-foreground">и&nbsp;составим план обучения</p>

          <ContactForm entryPoint="LANDING_PAGE" buttonText="Записаться" onFormSubmit={handleContactFormSubmit} />
        </CardCustom>
      </div>
    </Article>;
};